import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
const ICodeEditorService = ( createDecorator('codeEditorService'));
export { ICodeEditorService };
